import { select, takeLatest, all, put } from 'redux-saga/effects';
import { privateCall } from './api.saga';
import { assetViewerActions } from '../reducers/assetViewer.reducer';

function* index({ payload }) {
	try {
		payload.apiID = 'asset-viewer-index';

		const endpoint = yield select(s => s.config.endpoints.assetViewer.index);
		const { index } = yield privateCall({ endpoint, payload, method: 'get' });

		if (JSON.stringify(index).length === 2)
			payload.page = yield select(s => s.assetViewer.filter.page);

		yield put(assetViewerActions.setIndex({ index, filters: payload }));
	} catch (e) {}
}

function* modal({ payload }) {
	try {
		payload.apiID = 'asset-viewer-index';

		const endpoint = yield select(s => s.config.endpoints.assetViewer.index);
		const { index } = yield privateCall({ endpoint, payload, method: 'get' });

		yield put(assetViewerActions.setIndex({ index }));
	} catch (e) {}
}

export default function* assetViewerSaga() {
	yield all([
		yield takeLatest(assetViewerActions.index, index),
		yield takeLatest(assetViewerActions.modal, modal),
	]);
}
